import { Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";

import ResetPasswordForm from "../components/ResetPasswordForm";
import UpdatePasswordForm from "../components/UpdatePasswordForm";

export default function ResetPasswordScreen() {
    const { t } = useTranslation("auth");
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                minHeight: "100vh",
            }}
        >
            <GaiaPageComponent title={t("resetPasswordScreen.title")}>
                {!token && <ResetPasswordForm />}
                {token && <UpdatePasswordForm token={token} />}
            </GaiaPageComponent>
        </Container>
    );
}
